import Ax from './axios'

export function GetCommentList (data) {  // 评论列表
    return Ax.post('Comment/List', {...data}).then(
        res => res.data
    )
}

export function GetReplyList (data) {  // 二级评论列表
    return Ax.post('Comment/ReplyList', {...data}).then(
        res => res.data
    )
}

export function AddComment (data) {  // 新增评论
    return Ax.post('Comment/AddComment', {...data}).then(
        res => res.data
    )
}

export function FileUpload (data) {  // 新增图片
    return Ax.post('File/Upload', data).then(
        res => res.data
    )
}

export function FileUploadByBase64 (data) {  // 新增图片
    return Ax.post('File/UploadBase64', data).then(
        res => res.data
    )
}

export function DelComment (data) {  // 删除评论
    return Ax.post('Comment/Delete', {...data}).then(
        res => res.data
    )
}

export function GetMsgList (data) {  // 获取消息列表
    return Ax.post('Comment/MsgList', {...data}).then(
        res => res.data
    )
}

export function GetMsgTotal (data) {  // 获取未读消息总数
    return Ax.post('Comment/Total', {...data}).then(
        res => res.data
    )
}



// WEBPACK FOOTER //
// ./src/api/comments.js